import React from 'react';
import {Link} from "react-router-dom";
import { useLocation} from "react-router";
import { FieldTableColumnProps } from '../../components/FieldTable/FieldTableTypes';
import {
  SalesTeam,
  SalesTeamQueryDocument,
  useSalesTeamMutationMutation
} from '../../generated/graphql';
import {SideList} from "../../components/SideList";

/*
function convertVariables(initialValues,values) {
  graphqlSetLookups(['defaultCurrency','proposalOptions','manager']);
  return {input:graphqlObjectToInput(initialValues, values)};
}
*/
/*
function blankValues() {
  return {
    name:'',
    prefix:'',
    document_footer:'',
    contact_email:'',
    url:'',
    defaultCurrency:null,
    supports_commission:false,
    disclaimer_commission:'',
    commission_financial_notes:'',
    include_dashboard_all:true,
    proposalOptions:[]
  };
}
*/

export function SalesTeams() {
  const location = useLocation();
  //const user = useUserContext();
  //const updateMutation = useMutation(salesTeamMutation);
  const deleteMutation = useSalesTeamMutationMutation();
  const columns:FieldTableColumnProps<SalesTeam>[] = [
    {
      accessor:'name',
      header: 'Name',
      dataType:'link',
      // eslint-disable-next-line react/display-name
      options: {
        getLink:({field,row})=> {
          return ({
            pathname: '/settings/sales-teams/' + row.id,
            search: (location.search ? location.search : '')
          });
        }
      }
    },
    {
      accessor:'prefix',
      header:'Prefix',
      dataType:'default',
    },
    {
      accessor:'defaultCurrency.label',
      header:'Currency',
      dataType:'default',
    }
  ];
  return <SideList
      searchForm={null}
      label="Sales Teams"
      className="sales-teams"
      permission="salesteams"
      deleteMutation={deleteMutation}
      query={SalesTeamQueryDocument}
      columns={columns}
      baseUrl="/settings/sales-teams/"
      mode={null}
      noEditorScroll={null}
  />;
}

